const MainState = {
    contact: [],
    refreshContact:false,
    addContactMessage: {},
    messageAdded:false,
    messageError: ""
 }
 export default MainState;